import AsyncStorage from "@react-native-async-storage/async-storage";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PersistConfig, persistReducer } from "redux-persist";

export interface DateTimeState {
  dateFormat: string;
  timeFormat: string;
  dateTimeFormat: string;
}

const initialState: DateTimeState = {
  dateFormat: "DD/MM/YYYY",
  timeFormat: "HH:mm",
  dateTimeFormat: "DD/MM/YYYY HH:mm",
};

const dateTimeSlice = createSlice({
  name: "dateTime",
  initialState,
  reducers: {
    setDateFormat: (state: DateTimeState, action: PayloadAction<string>) => {
      state.dateFormat = action.payload;
    },
    setTimeFormat: (state: DateTimeState, action: PayloadAction<string>) => {
      state.timeFormat = action.payload;
    },
    setDateTimeFormat: (state: DateTimeState, action: PayloadAction<string>) => {
      state.dateTimeFormat = action.payload;
    },
  },
});

const persistConfig: PersistConfig<DateTimeState> = {
  key: "dateTime",
  storage: AsyncStorage,
  whitelist: ["dateFormat", "timeFormat", "dateTimeFormat"],
};

export const dateTimeActions = dateTimeSlice.actions;

export default persistReducer(persistConfig, dateTimeSlice.reducer);
